import * as React from 'react';
import styled from 'styled-components';
import { FieldError } from 'react-hook-form';
import { TextFieldProps } from '@material-ui/core';
import CurrencyInput from 'react-currency-input-field';

import { LabelForm } from '../atoms';

const InputCurrencyWithLabel = ({
  isRequired,
  label,
  error,
  allowDecimals = true,
  onCurrencyChange,
  disabled = false,
  ...props
}: Props) => {
  const { id, name, value } = props;

  return (
    <InputContainer>
      <LabelForm
        htmlFor={id || name}
        isRequired={isRequired}
      >
        {label}
      </LabelForm>
      <StyledCurrencyInput
        id={id || name}
        name={name}
        error={!!error}
        required={isRequired}
        onChange={onCurrencyChange}
        allowDecimals={allowDecimals}
        prefix="$"
        value={value}
        disabled={disabled}
      />
      {error && (
        <span
          style={{
            color: 'var(--danger-600)',
            fontSize: 'var(--fs-sm)',
            marginTop: '4px',
          }}
        >
          {error?.message ? error?.message : error}
        </span>
      )}
    </InputContainer>
  );
};

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;

  label {
    margin-bottom: 8px;
  }
`;

const StyledCurrencyInput = styled(({ error, ...rest }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <CurrencyInput {...rest} />
))`
  text-align: right;
  border-radius: var(--radius-md);
  padding: 0;
  height: 40px;
  width: 100%;
  color: var(--neutral-800);
  font-size: var(--fs-base);
  font-family: inherit;
  background: var(--neutral-0);
  box-shadow: none;
  border: 1px solid var(--neutral-300);
  outline: none;
  transition:
    border-color var(--motion-fast) var(--ease-standard),
    box-shadow var(--motion-fast) var(--ease-standard);

  &:hover {
    border-color: var(--neutral-400);
  }

  &:focus {
    border-color: var(--primary-600);
    box-shadow: var(--shadow-focus);
  }

  &:disabled {
    background: var(--neutral-100);
    color: var(--neutral-500);
    cursor: not-allowed;
  }

  ${props =>
    props.error &&
    `
    border-color: var(--danger-500);
    &:focus {
      box-shadow: var(--shadow-focus-danger);
    }
  `}
`;

type Props = Omit<TextFieldProps, 'error' | 'variant'> & {
  isRequired?: boolean;
  error?: FieldError;
  allowDecimals?: boolean;
  onCurrencyChange: (value: string, name: string) => void;
};

export default InputCurrencyWithLabel;
